import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { Heart, Users, Menu, X } from 'lucide-react';

const Layout = () => {
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col font-sans">
            <header className="bg-white shadow-sm sticky top-0 z-50">
                <div className="container mx-auto px-4 py-4 flex justify-between items-center">
                    <Link to="/" className="flex items-center space-x-2 text-pink-600 hover:text-pink-700 transition-colors">
                        <Heart className="w-8 h-8 fill-current" />
                        <span className="text-2xl font-bold tracking-tight">ForeverUnion</span>
                    </Link>

                    <nav className="hidden md:flex space-x-8 items-center">
                        <Link to="/" className="text-gray-600 hover:text-pink-600 font-medium transition-colors">Home</Link>
                        <Link to="/delhi-matrimony" className="text-gray-600 hover:text-pink-600 font-medium transition-colors">Delhi Matrimony</Link>
                        <Link to="/mumbai-matrimony" className="text-gray-600 hover:text-pink-600 font-medium transition-colors">Mumbai Matrimony</Link>
                        <button className="bg-pink-600 text-white px-5 py-2 rounded-full font-medium hover:bg-pink-700 transition-colors shadow-md hover:shadow-lg transform hover:-translate-y-0.5">
                            Login
                        </button>
                    </nav>

                    <button className="md:hidden text-gray-600" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                        {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                    </button>
                </div>

                {/* Mobile menu */}
                {isMenuOpen && (
                    <div className="md:hidden bg-white border-t border-gray-100 py-4 px-4 space-y-3">
                        <Link to="/" className="block text-gray-600 hover:text-pink-600 font-medium py-2" onClick={() => setIsMenuOpen(false)}>Home</Link>
                        <Link to="/delhi-matrimony" className="block text-gray-600 hover:text-pink-600 font-medium py-2" onClick={() => setIsMenuOpen(false)}>Delhi Matrimony</Link>
                        <Link to="/mumbai-matrimony" className="block text-gray-600 hover:text-pink-600 font-medium py-2" onClick={() => setIsMenuOpen(false)}>Mumbai Matrimony</Link>
                    </div>
                )}
            </header>

            <main className="flex-grow">
                <Outlet />
            </main>

            <footer className="bg-gray-900 text-white pt-12 pb-6">
                <div className="container mx-auto px-4">
                    <div className="grid md:grid-cols-4 gap-8 mb-8">
                        <div>
                            <div className="flex items-center space-x-2 text-pink-500 mb-4">
                                <Heart className="w-6 h-6 fill-current" />
                                <span className="text-xl font-bold">ForeverUnion</span>
                            </div>
                            <p className="text-gray-400 text-sm leading-relaxed">
                                Connecting souls, creating families. The most trusted matrimony service.
                            </p>
                        </div>
                        <div>
                            <h4 className="font-bold text-lg mb-4">Quick Links</h4>
                            <ul className="space-y-2 text-gray-400 text-sm">
                                <li><Link to="/" className="hover:text-pink-400">Home</Link></li>
                                <li><Link to="/about" className="hover:text-pink-400">About Us</Link></li>
                                <li><Link to="/contact" className="hover:text-pink-400">Contact</Link></li>
                                <li><Link to="/sitemap" className="hover:text-pink-400">Sitemap</Link></li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="font-bold text-lg mb-4">Matrimony Sites</h4>
                            <ul className="space-y-2 text-gray-400 text-sm">
                                <li><Link to="/delhi-matrimony" className="hover:text-pink-400">Delhi Matrimony</Link></li>
                                <li><Link to="/mumbai-matrimony" className="hover:text-pink-400">Mumbai Matrimony</Link></li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="font-bold text-lg mb-4">Newsletter</h4>
                            <div className="flex">
                                <input type="email" placeholder="Your email" className="bg-gray-800 text-white px-4 py-2 rounded-l-md w-full focus:outline-none focus:ring-1 focus:ring-pink-500" />
                                <button className="bg-pink-600 px-4 py-2 rounded-r-md hover:bg-pink-700 transition-colors">
                                    Subscribe
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="border-t border-gray-800 pt-6 text-center text-gray-500 text-xs">
                        © {new Date().getFullYear()} ForeverUnion. All rights reserved.
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Layout;
